const parseLines = (value) => value.replace(/(\\n)/g, '\n').replace(/\\/g, '');
export default parseLines;
